import { Link, useLocation } from '@reach/router';
import clsx from 'clsx';
import { FC, HTMLProps } from 'react';
import { useTranslation } from 'react-i18next';

import { Icon } from 'components/Icon';
import { Header } from 'components/PageLayout/Header';

import styles from './styles.module.scss';

type giftCardLocationState = {
  isFromGiftCard?: boolean;
}

export type CheckoutHeaderProps = HTMLProps<HTMLElement>;

export const CheckoutHeader: FC<CheckoutHeaderProps> = ({ className, children, ...props }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const { isFromGiftCard } = location?.state as giftCardLocationState || {};

  return (
    <Header className={clsx(styles.header, className)} hideLogo {...props}>
      <div className={styles.navContainer}>
        <h1 className={clsx('h3', styles.checkoutHeader)}>
          <Link to={isFromGiftCard ? '../giftcard' :'../'}>
            <Icon name={'leftarrow'} aria-hidden={true} />
            {t('checkout')}
          </Link>
        </h1>
      </div>
      <div className={styles.callToAction}>
        {children}
      </div>
    </Header>
  );
};
